// emails.an / emails.cc sind text[] (Graph-Sync und graph-mail-send schreiben Arrays;
// DB-Bestand am 2026-07-08 vollständig geprüft — der frühere Komma-String-Altbestand ist weg).
export const toEmpfaengerListe = (v: unknown): string[] =>
  Array.isArray(v) ? v.map((e) => String(e).trim()).filter(Boolean) : [];

export const empfaengerAlsText = (v: unknown): string => toEmpfaengerListe(v).join(', ');

// Eine Adresse ist nur gültig, wenn NICHTS daran klebt. Die alte Prüfung im Composer
// (/^[^\s@]+@[^\s@]+\.[^\s@]+$/) ließ Trennzeichen durch: „a@x.de;" bestand sie, und
// Graph lehnte daraufhin die KOMPLETTE Mail ab (ErrorInvalidRecipients, Live-Bug
// 2026-08-13 — sechs Sendeversuche scheiterten an einem einzigen Semikolon).
const ADRESSE = /^[^\s@,;<>"()[\]\\]+@[^\s@,;<>"()[\]\\.]+(\.[^\s@,;<>"()[\]\\.]+)+$/;

export const istGueltigeAdresse = (wert: unknown): boolean => ADRESSE.test(String(wert ?? '').trim());

/**
 * Zerlegt eine Empfänger-Eingabe in saubere Einzeladressen — genau das, was beim
 * Einfügen einer Outlook-Liste („a@x.de; b@y.de;") erwartet wird. Trennt an
 * Semikolon/Komma/Whitespace, schält „Name <adresse>" ab, wirft Unbrauchbares weg
 * und entdoppelt (ohne Rücksicht auf Groß-/Kleinschreibung, Schreibweise bleibt).
 */
export function adressenAusEingabe(roh: string): string[] {
  const gesehen = new Set<string>();
  const raus: string[] = [];
  for (const stueck of String(roh ?? '').split(/[;,\s]+/)) {
    const adresse = stueck.replace(/^</, '').replace(/>$/, '').trim();
    if (!istGueltigeAdresse(adresse)) continue;
    const schluessel = adresse.toLowerCase();
    if (gesehen.has(schluessel)) continue;
    gesehen.add(schluessel);
    raus.push(adresse);
  }
  return raus;
}
